module.exports = __webpack_public_path__ + "img/mp-img-5.54460a69.jpg";